import React from "react";
import BarracksDialogs from "./BarracksDialogs";
import BarracksHeader from "./BarracksHeader";
import BarracksPage from "./BarracksPage";

const BarracksWrapper = () => {
  return (
    <>
      <BarracksHeader />

      <BarracksPage />

      <BarracksDialogs />
    </>
  );
};

export default BarracksWrapper;
